import { render, staticRenderFns } from "./alarms-list-table.vue?vue&type=template&id=3fad9a10&"
import script from "./alarms-list-table.vue?vue&type=script&lang=js&"
export * from "./alarms-list-table.vue?vue&type=script&lang=js&"
import style0 from "./alarms-list-table.vue?vue&type=style&index=0&id=3fad9a10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports